<template>
  <HomepageWideLayout heroDark>
    <section>
      <!-- header slot -->
      <SecondaryHeader>
        <h2>Pricing</h2>
        <p class="body">
          Get high-quality business cards, free second-side printing, and free delivery.
          The Brandly app is also free so you only pay for the cards you order.
        </p>
      </SecondaryHeader>
      <b-container id="pricing-layer">
        <div class="pricing">
          <div class="inside-wrapper">
          <div class="copy-container">
            <h2>Paper Options</h2>
            <p class="body">
              We offer papers in a wide variety of coatings, thicknesses, and textures to best fit your brand and budget.
            </p>
          </div>
          </div>
        </div>
        <PricingGrid selected="Standard" />
      </b-container>
      <Portal />
      <GetQuote />
      <Demo />
    </section>
  </HomepageWideLayout>
</template>



<style lang="scss" scoped>
@import "~scss/colors";

#pricing-layer {
  padding-top: 2em;
  padding-bottom: 2em;
}

.inside-wrapper {
  padding: 0 1em;
  margin: 0 auto;
   @media (max-width: 992px) {
    padding:0;
  }
}

.h2-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pricing {
  padding: 1em 1em 0 1em;
  margin: 0 auto;
}

.copy-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1em;
   @media (max-width: 992px) {
    padding: 0 .5rem;
  }
}

/* media queries body */

@media (max-width: 992px) {
  .layer {
    padding-top: .5em;
  }
  .container{
     width: 500px;
     margin:0 auto;
     padding: 0;
  }
  .pricing{
    margin: 1em 0 0 0;
    padding: 0;
  }
  .copy,
  .h2-copy {
    height: 100%;
  }
  #long-text {
    padding: 0;
  }
}

/* small device */

@media (max-width: 576px) {
  #pricing-layer {
    margin: 0;
    padding: 2em 1em;
    width: 100%;
  }
  .pricing {
    margin: 0;
  }
  .copy-container {
    width: 100%;
    padding: 0;
  }
  h2 {
    font-size: larger;
    margin-bottom: .5em;
  }
  .copy-container p {
    font-size: medium;
    line-height: 1.3;
  }
  .layer {
    margin: 0;
    padding: 0;
  }
}

</style>

<script>
import TopPapers from "./pricing/TopPapers";
import PricingGrid from "./pricing/PricingGrid";
import Portal from "./pricing/Portal";
export default {
  components: { TopPapers, PricingGrid, Portal }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/Pricing.vue